import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Compass, MapPin, UserCircle } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { RANGER_AVATAR } from "@/lib/constants";
import ToursManager from "@/pages/owner/ToursManager";
import OperatorProfileEditor from "@/pages/operator/OperatorProfileEditor";
import Seo from "@/components/Seo";

const TABS = [
  { id: "tours", label: "Tours", icon: MapPin },
  { id: "profile", label: "Public Profile", icon: UserCircle },
];

export default function OperatorDashboard() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [tab, setTab] = useState("tours");
  useEffect(() => {
    if (!loading && !user) nav("/owner/login");
    else if (!loading && user && user.role === "owner") nav("/owner");
  }, [user, loading, nav]);
  if (loading || !user) return <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center text-neutral-500">Loading...</div>;

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Seo title="Operator Dashboard" description="Manage your Visit RiNo tours and experiences." />
      <header className="glass border-b border-white/10 sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src={RANGER_AVATAR} alt="" className="w-8 h-8 object-cover border border-[#FF0055]" />
            <span className="font-display font-extrabold text-white">VISIT<span className="text-[#FF0055]">RiNo</span> <span className="text-neutral-500 text-sm font-normal">Operator</span></span>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-neutral-400 text-sm hidden sm:block">{user.name || user.email}</span>
            <button onClick={() => { logout(); nav("/"); }} data-testid="operator-logout" className="text-neutral-400 hover:text-[#FF0055] flex items-center gap-1 text-sm"><LogOut size={16} /> Sign out</button>
          </div>
        </div>
      </header>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center gap-3 mb-6 border border-[#00E5FF]/20 bg-[#00E5FF]/5 p-4">
          <Compass size={22} className="text-[#00E5FF] flex-shrink-0" />
          <p className="text-neutral-300 text-sm">Welcome, {user.name || "operator"}! List the tours and experiences you run in RiNo and build your public profile so visitors can find and trust you.</p>
        </div>
        <div className="flex gap-2 mb-8 border-b border-white/10">
          {TABS.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)} data-testid={`operator-tab-${t.id}`}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === t.id ? "border-[#FF0055] text-white" : "border-transparent text-neutral-400 hover:text-white"}`}>
              <t.icon size={15} /> {t.label}
            </button>
          ))}
        </div>
        {tab === "tours" && <ToursManager />}
        {tab === "profile" && <OperatorProfileEditor />}
      </div>
    </div>
  );
}
